<div class="anlage-list-grid">
  <div class="cell-toolbar">
    <cst-toolbar>
      <ctrl-btn-create
        i18n-content="
          @@InfoPortal_CustomerFacilitiesManage_BuFacilityCreate_Content"
        content="Create"
        i18n-title="
          @@InfoPortal_CustomerFacilitiesManage_BuFacilityCreate_Title"
        title="Create a new facility and assign it to this customer"
        (click)="onFacilityCreate()"
        [disabled]="!canFacilityCreate()"
      ></ctrl-btn-create>
      <ctrl-btn
        icon="done_all"
        (click)="onFacilitiesSelectAndAssign()"
        i18n-content="
          @@InfoPortal_CustomerFacilitiesManage_BuFacilitiesSelect_Content"
        content="Assign"
        i18n-title="
          @@InfoPortal_CustomerFacilitiesManage_BuFacilitiesSelect_Title"
        title="Select facilities to assign to this customer"
        [disabled]="!canFacilitiesSelectAndAssign()"
      ></ctrl-btn>
      <ctrl-btn
        icon="remove_done"
        (click)="onFacilitiesUnassign()"
        i18n-content="
          @@InfoPortal_CustomerFacilitiesManage_BuFacilitiesUnassign_Content"
        content="Unassign"
        i18n-title="
          @@InfoPortal_CustomerFacilitiesManage_BuFacilitiesUnassign_Title"
        title="Unassign selected facilities from customer"
        [disabled]="selected.length == 0"
      ></ctrl-btn>
    </cst-toolbar>
  </div>
  <div class="cell-list">
    <app-list-view
      [dataSource]="dataSource"
      [columns]="columns"
      [actions]="actions"
      [elevated]="false"
      [selectionEnabled]="true"
      (selectionChanged)="onSelectionChanged($event)"
    ></app-list-view>
  </div>
</div>
